import type { EventType } from "app/types/eventType";
import type { Element } from "React";
import { Component } from "react";
import "./TeamsMarketTypeSubheading.scss";
type Props = {
  event: EventType;
};

class TeamsMarketTypeSubheading extends Component<Props> {
  render(): Element<"div"> {
    const { event } = this.props;
    return (
      <div className={"subheading binary"}>
        <span key={event.participant1 + event.id}>{event.participant1}</span>
        <span key={event.participant2 + event.id}>{event.participant2}</span>
      </div>
    );
  }
}

export default TeamsMarketTypeSubheading;
